<div [ngClass]="{'content-overlay' : isModal}">
    <div class="single" id="single-form">
        <a class="cta cta--red single__close" *ngIf="isModal && isInitialized" (click)="_closeCallback()"><span class="ico-remove"></span> Zavřít</a>
        <form [formGroup]="form" (ngSubmit)="save()" method="post" *ngIf="isInitialized">
            <swb-form-fields [fields]="formEditors" [form]="form"></swb-form-fields>
            <div class="align-right">
                <button type="submit" class="cta cta--blue submit" [ngClass]="{'submit--submitting': isSaving}"
                    [disabled]="isSaving">
                    <i class="ico-save"></i> Uložit</button>
            </div>
        </form>
        <div *ngIf="!isInitialized" class="loading loading--padding loading--white"></div>
    </div>
</div>